import { Component, Input } from "@angular/core";

@Component({
    selector: 'phc-analysis-warning-card',
    templateUrl: './analysis-warning-card.component.html',
})
export class AnalysisWarningCardComponent {

    @Input() orderStatus: string;
}